import { render, staticRenderFns } from "./AddClients.vue?vue&type=template&id=a41e1162&scoped=true&"
import script from "./AddClients.vue?vue&type=script&lang=js&"
export * from "./AddClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41e1162",
  null
  
)

export default component.exports